import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  capacityDate: () => Date.now(),
  capacityLimit: 100,
  onSiteCount: () =>
    faker.number.int({
      min: 0,
      max: 60,
    }),
  expectedCount: () =>
    faker.number.int({
      min: 0,
      max: 60,
    }),
  inCount: () =>
    faker.number.int({
      min: 0,
      max: 120,
    }),
  outCount: () =>
    faker.number.int({
      min: 0,
      max: 120,
    }),
  afterCreate(locationsCapacity) {
    const { location, company } = locationsCapacity;
    if (!company && location) {
      locationsCapacity.update({ company: location.company });
    }
  },
});
